import React from 'react';
import PropTypes from 'prop-types';
import { Redirect as ReactRouterRedirect, Route } from 'react-router-dom';

const Redirect = ({ from, statusCode, ...restProps }) => (
  <Route
    path={from}
    render={({ staticContext }) => {
      if (staticContext) {
        // Set the statusCode so that it can be used for the redirect.
        // eslint-disable-next-line no-param-reassign
        staticContext.statusCode = statusCode;
      }
      return (
        <ReactRouterRedirect {...restProps} />
      );
    }}
  />
);

Redirect.propTypes = {
  from: PropTypes.string,
  statusCode: PropTypes.number.isRequired,
};

export default Redirect;
